import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import favicon from "../../ReqsAndAssets/1 - Brand Assets/Logos/Favicon.png";
import { AdminApp } from "./AdminApp";
import { ParticipantApp } from "./ParticipantApp";
import "./styles.css";

const link = document.createElement("link");
link.rel = "icon";
link.href = favicon;
document.head.appendChild(link);

const path = window.location.pathname;
const resultMatch = path.match(/^\/results\/([^/]+)\/?$/);
const resumeMatch = path.match(/^\/resume\/([^/]+)\/?$/);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {path.startsWith("/admin") ? (
      <AdminApp />
    ) : (
      <ParticipantApp
        resultToken={resultMatch ? decodeURIComponent(resultMatch[1]) : undefined}
        resumeToken={resumeMatch ? decodeURIComponent(resumeMatch[1]) : undefined}
      />
    )}
  </StrictMode>,
);
